import { createItemImageColumnDefinition } from '../../../items/items-table/columns/item-image';
import { createItemNameColumnDefinition } from '../../../items/items-table/columns/item-name';
import { createItemQuantityColumnDefinition } from '../../../items/items-table/columns/item-quantity';
import { createItemStockColumnDefinition } from '../../../items/items-table/columns/item-stock';
import { createItemTotalColumnDefinition } from '../../../items/items-table/columns/item-total';
import { createItemUnitCostColumnDefinition } from '../../../items/items-table/columns/item-unit-cost';

const columns = [
  createItemNameColumnDefinition(),
  createItemImageColumnDefinition(),
  createItemUnitCostColumnDefinition(),
  createItemQuantityColumnDefinition(),
  createItemStockColumnDefinition(),
  createItemTotalColumnDefinition(),
];

export default columns;
